import http from "@/http";

const StatusProjetoService = {
  async buscarLkpStatusProjeto() {
    try {
      const response = await http.get("/api/astec/getLkpStatusProjeto");

      return response.data.map(statusProjeto => ({
        name: statusProjeto.DISPLAY,
        value: statusProjeto.ID,
      }));
    } catch (error) {
      console.log("Erro ao carregar Status do Projeto", error);
      throw error;
    }
  },
};

export default StatusProjetoService;
